import React from 'react';
import { Link } from 'react-router-dom';
import creativesRegistry from '../data/creativesRegistry';

const CreativesListPage = () => {
    return (
        <div className="min-h-screen bg-black text-white py-20 px-6">
            <div className="max-w-7xl mx-auto">
                <h1 className="text-6xl font-bold mb-4 text-center bg-gradient-to-r from-purple-400 via-pink-400 to-cyan-400 bg-clip-text text-transparent">
                    Creatives
                </h1>
                <p className="text-center text-gray-400 mb-16 text-lg">
                    Interactive creative animations and effects
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {creativesRegistry.map((creative) => (
                        <Link
                            key={creative.id}
                            to={`/creatives/${creative.slug}`}
                            className="group relative bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 border border-gray-700 hover:border-purple-500 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-purple-500/20"
                        >
                            {/* Card glow effect */}
                            <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-purple-500/10 via-pink-500/10 to-cyan-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

                            <div className="relative z-10">
                                <div className="mb-4">
                                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center text-3xl">
                                        👻
                                    </div>
                                </div>

                                <h3 className="text-2xl font-bold mb-2 text-white group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-purple-400 group-hover:to-pink-400 group-hover:bg-clip-text transition-all duration-300">
                                    {creative.name}
                                </h3>

                                <p className="text-gray-400 text-sm mb-4">
                                    {creative.description}
                                </p>

                                <div className="flex items-center justify-between">
                                    <span className="text-xs px-3 py-1 rounded-full bg-purple-500/20 text-purple-300 border border-purple-500/30">
                                        {creative.category}
                                    </span>

                                    <span className="text-purple-400 group-hover:translate-x-1 transition-transform duration-300">
                                        →
                                    </span>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>

                {creativesRegistry.length === 0 && (
                    <div className="text-center py-20">
                        <p className="text-gray-500 text-xl">No creatives available yet.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CreativesListPage;
